var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.175 20V18.5H7.425L7.05 18.2C5.98333 17.35 5.20833 16.425 4.725 15.425C4.24167 14.425 4 13.3083 4 12.075C4 10.3083 4.52083 8.72083 5.5625 7.3125C6.60417 5.90417 7.975 4.93333 9.675 4.4V5.95C8.425 6.43333 7.41667 7.2375 6.65 8.3625C5.88333 9.4875 5.5 10.725 5.5 12.075C5.5 13.125 5.69583 14.0375 6.0875 14.8125C6.47917 15.5875 7.00833 16.2583 7.675 16.825L8.425 17.35V14.25H9.925V20H4.175ZM14.35 19.625V18.05C15.6167 17.5667 16.625 16.7625 17.375 15.6375C18.125 14.5125 18.5 13.275 18.5 11.925C18.5 11.125 18.3042 10.3125 17.9125 9.4875C17.5208 8.6625 17.0083 7.93333 16.375 7.3L15.65 6.65V9.75H14.15V4H19.9V5.5H16.625L17 5.85C18 6.78333 18.75 7.78333 19.25 8.85C19.75 9.91667 20 10.9417 20 11.925C20 13.6917 19.4833 15.2833 18.45 16.7C17.4167 18.1167 16.05 19.0917 14.35 19.625Z",
    fill: "url(#paint0_linear_334_342)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_342",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpro);
export default __webpack_public_path__ + "static/media/simpro.b5b22ac304bcb4d146b92689ca3288ab.svg";
export { ForwardRef as ReactComponent };